import { createEntityQueryKeys } from '@/shared/lib'

export const telegramAccountKeys = createEntityQueryKeys(['telegram-account'])
